import { Container } from "@mui/material";
import TablaCarpetaV2 from "@/components/Tablas/TablaCarpetaV2";
import { TablaCarpetaProvider } from "@/components/Tablas/TablaCarpetaV2/logics/TablaCarritoProvider";
import { ViewAs } from "@/components/Tablas/TablaCarpetaV2/logics/useTablaCarritoV2";

const DevPage = () => {
    return (<>
        <Container maxWidth="lg">
            <h1>Dev Page</h1>

            <TablaCarpetaProvider viewAs={ViewAs.ADMIN}>
                <TablaCarpetaV2 />
            </TablaCarpetaProvider>

        </Container>


    </>);
}

export default DevPage;